export default __webpack_public_path__ + "static/media/abtLizMob.40cd540c.jpg";